import { useState, useEffect, useRef } from "react";
import { FaClock } from "react-icons/fa6";
import { MdRefresh } from "react-icons/md";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoginService from "../../../services/Login";
import { showToast } from "../../../redux/slices/toastSlice";
import { setToken } from "../../../redux/slices/loginSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/slices/userSlice";
import {
  FaBitcoin,
  FaDollarSign,
  FaChartLine,
  FaEthereum,
  FaCoins,
  FaSignal,
  FaChartArea,
  FaChartPie,
  FaMoneyBillWave,
  FaArrowTrendUp,
  FaScaleBalanced,
} from "react-icons/fa6";
import { FaExchangeAlt, FaArrowLeft } from "react-icons/fa";

export default function CodeStep({ code, setCode, authData, setStep }) {
  const bgIcons = [
    {
      Icon: FaBitcoin,
      className: "text-yellow-300/40",
      style: { top: "6%", left: "4%", animationDelay: "0s", fontSize: 20 },
    },
    {
      Icon: FaDollarSign,
      className: "text-white",
      style: { top: "14%", right: "8%", animationDelay: "0.6s", fontSize: 20 },
    },
    {
      Icon: FaEthereum,
      className: "text-white/90",
      style: { top: "16%", left: "7%", animationDelay: "1.2s", fontSize: 18 },
    },
    {
      Icon: FaChartLine,
      className: "text-white/55",
      style: { top: "20%", right: "6%", animationDelay: "1.8s", fontSize: 26 },
    },
    {
      Icon: FaCoins,
      className: "text-white/70",
      style: {
        bottom: "72%",
        right: "8%",
        animationDelay: "0.9s",
        fontSize: 18,
      },
    },
    {
      Icon: FaSignal,
      className: "text-white/70",
      style: {
        bottom: "15%",
        left: "3%",
        animationDelay: "2.2s",
        fontSize: 26,
      },
    },
    {
      Icon: FaChartArea,
      className: "text-white/60",
      style: {
        bottom: "16%",
        right: "10%",
        animationDelay: "1.4s",
        fontSize: 18,
      },
    },
    {
      Icon: FaChartPie,
      className: "text-white/60",
      style: { top: "96%", left: "10%", animationDelay: "2.5s", fontSize: 22 },
    },
    {
      Icon: FaMoneyBillWave,
      className: "text-white/60",
      style: { top: "22%", left: "10%", animationDelay: "2.5s", fontSize: 18 },
    },
    {
      Icon: FaChartLine,
      className: "text-white/60",
      style: { top: "28%", left: "2%", animationDelay: "1.4s", fontSize: 22 },
    },
    {
      Icon: FaExchangeAlt,
      className: "text-white/100",
      style: { top: "90%", left: "2%", animationDelay: "1.8s", fontSize: 15 },
    },
    {
      Icon: FaArrowTrendUp,
      className: "text-black",
      style: { top: "90%", left: "92%", animationDelay: "3.5s", fontSize: 15 },
    },
    {
      Icon: FaScaleBalanced,
      className: "text-yellow-900/90",
      style: { top: "70%", left: "92%", animationDelay: "4.5s", fontSize: 20 },
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [time, setTime] = useState(180);
  const [loading, setLoading] = useState(false);
  const [falseOtp, setFalseOtp] = useState(false);
  const [errMess, setErrMess] = useState("");
  const hiddenOtpRef = useRef(null);

  useEffect(() => {
    hiddenOtpRef.current?.focus();
  }, []);

  useEffect(() => {
    if (time <= 0) return;
    const interval = setInterval(() => setTime((prev) => prev - 1), 1000);
    return () => clearInterval(interval);
  }, [time]);

  const [otpValues, setOtpValues] = useState(["", "", "", "", ""]);

  // const handleOtpChange = (index, value) => {
  //   const digit = value.replace(/\D/g, "");
  //   if (digit.length > 1) return;
  //
  //   const newOtp = [...otpValues];
  //   newOtp[index] = digit;
  //   setOtpValues(newOtp);
  //   setCode(newOtp.join(""));
  //
  //   if (digit && index < 4) {
  //     otpRefs[index + 1].current?.focus();
  //   }
  // };

  // const handleOtpKeyDown = (index, e) => {
  //   if (e.key === "Backspace") {
  //     if (otpValues[index]) {
  //       const newOtp = [...otpValues];
  //       newOtp[index] = "";
  //       setOtpValues(newOtp);
  //       setCode(newOtp.join(""));
  //     } else if (index > 0) {
  //       otpRefs[index - 1].current?.focus();
  //     }
  //   }
  // };

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  async function submiOtp(e) {
    e.preventDefault();

    if (code.length !== 5) return;

    setLoading(true);

    try {
      const body = {
        email: authData.email,
        sentCode: code,
      };

      const res = await LoginService.submitOtpEmail(body);

      if (res.status === 200) {
        const token = res?.data?.data?.tokens?.accessToken;

        dispatch(setToken(token));

        axios.defaults.headers.common.Authorization = `Bearer ${token}`;

        setFalseOtp(false);

        navigate("/");
      }
   } catch (err) {
  setFalseOtp(true);
  setErrMess(
    err.response?.data?.en_message ||
    "Something went wrong"
  );
} finally {
      setLoading(false);
    }
  }

  async function onResendOtpClick() {
    try {
      const res = await LoginService.emailSendOtp({
        email: authData.email,
      });

      if (res.status === 200) {
        dispatch(
          showToast({
            message:
              res?.data?.en_message ?? "Verification code sent successfully",
            type: "success",
          }),
        );

        setTime(180);

        setCode("");

        setOtpValues(["", "", "", "", ""]);

        setFalseOtp(false);

        hiddenOtpRef.current?.focus();
      }
    } catch (err) {
      console.error(err);

      dispatch(
        showToast({
          message: err?.data?.en_message ?? "Resending the code failed",
          type: "error",
        }),
      );
    }
  }

  return (
    <div className="relative min-h-screen overflow-hidden bg-gray-50 font-inter">
      <div className="gradient-bg">
        <div className="trading-pattern"></div>

        <div className="signal-wave top-[6%] left-0 animate-delay-0" />
        <div className="signal-wave top-[28%] left-0 animate-delay-2000" />
        <div className="signal-wave bottom-[28%] left-0 animate-delay-1000" />

        {bgIcons.map((it, idx) => {
          const { Icon, className, style } = it;
          return (
            <div
              key={idx}
              className={`floating-animation ${className}`}
              style={{
                position: "absolute",
                opacity: idx === 0 ? 0.95 : 0.18,
                ...style,
              }}
            >
              <Icon />
            </div>
          );
        })}
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center py-4 min-h-full px-6">
        <div id="header" className="p-4 w-full">
          <div className="flex items-center justify-between w-full">
            <button
              onClick={() => setStep(1)}
              className="p-2 -ml-2 rounded-lg bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-colors"
            >
              <FaArrowLeft className="text-xl text-white" />
            </button>
            <h1 className="text-lg font-bold text-white">Verify Code</h1>
            <div className="w-8"></div>
          </div>
        </div>

        <div className="text-center animate-fade-in">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg mb-2 animate-pulse">
            <FaChartLine className="text-2xl text-blue-600" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-1">7 Trade</h1>
          <p className="text-blue-100 text-xs">Trade Signal Navigator</p>
        </div>

        <div className="w-[350px] md:w-[500px] max-w-sm bg-white rounded-3xl shadow-2xl p-6 animate-slide-up scale-90">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-800 mb-3">
              Enter Verification Code
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-2">
              A 5-digit verification code has been sent to
            </p>

            <p className="font-semibold text-blue-600 text-sm break-all">
              {authData.email}
            </p>
          </div>

          <input
            ref={hiddenOtpRef}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="[0-9]*"
            value={code}
            tabIndex={0}
            className="absolute inset-0 w-1 h-1 z-0 opacity-0 caret-transparent"
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 5);

              setCode(value);

              setOtpValues(() => {
                const next = ["", "", "", "", ""];
                value.split("").forEach((d, i) => {
                  next[i] = d;
                });
                return next;
              });
            }}
          />

          <div
            className="flex justify-center gap-3 mb-8 ltr"
            onMouseDown={(e) => {
              e.preventDefault();
              hiddenOtpRef.current?.focus();
            }}
          >
            {otpValues.map((v, i) => (
              <input
                key={i}
                type="text"
                readOnly
                value={v}
                className="
                                        w-12 h-12
                                        text-center text-lg font-bold
                                        border-2 rounded-xl
                                        border-gray-300
                                        focus:border-blue-500
                                    "
              />
            ))}
          </div>

          {/* Timer */}
          <div id="timer-section" className="text-center mb-8">
            <div className="inline-flex items-center gap-3 bg-blue-50 px-6 py-3 rounded-full">
              <FaClock className="text-blue-600 text-lg" />
              <span className="text-gray-700 font-semibold" id="timer">
                {minutes}:{String(seconds).padStart(2, "0")}
              </span>
            </div>
          </div>

          {/* Submit Button */}
          <button
            dir="rtl"
            onClick={submiOtp}
            disabled={code.length < 5 || time === 0 || loading}
            className={`w-full py-4 rounded-2xl font-bold text-lg transition-all duration-300 shadow-lg mb-6 ${
              code.length < 5 || time === 0 || loading
                ? "bg-blue-400 text-white opacity-50 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700 active:scale-95"
            }`}
          >
            {loading ? "Please wait..." : "Verify Code"}
          </button>

          {/* Error Message */}
         {falseOtp && errMess && (
  <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl p-3 mb-4 text-sm text-center">
    {errMess}
  </div>
)}

          {/* Resend Section */}
          <div
            id="resend-section"
            className="text-center border-t border-gray-200 pt-4"
          >
            <p className="text-gray-500 text-md font-bold mb-2">
              Didn't receive the code?
            </p>
            <button
              onClick={onResendOtpClick}
              disabled={time > 0}
              className={`flex items-center justify-center text-md gap-2 mx-auto font-medium transition-colors 
                ${
                  time > 0
                    ? "text-gray-400 cursor-not-allowed"
                    : "text-blue-600 hover:text-blue-700 active:scale-95"
                }
                `}
            >
              <MdRefresh className={time > 0 ? "" : "animate-spin"} />
              Resend
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
